import { render, staticRenderFns } from "./RemindDialog.vue?vue&type=template&id=140a037e&scoped=true"
import script from "./RemindDialog.vue?vue&type=script&lang=js"
export * from "./RemindDialog.vue?vue&type=script&lang=js"
import style0 from "./RemindDialog.vue?vue&type=style&index=0&id=140a037e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a037e",
  null
  
)

export default component.exports